import { useEffect, useState } from 'react';

type State = {
  filters: Record<string, string> | null;
  params: Record<string, string | number>;
};

const defaultState: State = {
  filters: null,
  params: { page: 1 },
};

type UsePersistentPageStateOptions = {
  storageKey: string;
};

export default function usePersistentPageState({
  storageKey,
}: UsePersistentPageStateOptions) {
  // Initialize state directly with stored values
  const [filters, setFilters] = useState<Record<string, string>>(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (!raw) return defaultState.filters;

      const parsed = JSON.parse(raw);
      return parsed.filters || defaultState.filters;
    } catch (error) {
      return defaultState.filters;
    }
  });

  const [params, setParams] = useState<Record<string, string | number>>(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (!raw) return defaultState.params;

      const parsed = JSON.parse(raw);
      return parsed.params || defaultState.params;
    } catch (error) {
      return defaultState.params;
    }
  });

  // Save state to storage when it changes
  useEffect(() => {
    sessionStorage.setItem(storageKey, JSON.stringify({ filters, params }));
  }, [filters, params, storageKey]);

  return {
    filters,
    setFilters,
    params,
    setParams,
  };
}
